import type { Job } from '@/api/endpoints/jobs'

const FRIENDLY: Record<string, string> = {
  viral_shorts: 'Viral',
  atlas: 'Atlas',
  mirage: 'Mirage',
  pov_lives: 'POV Lives',
  reddit_stories: 'Reddit Stories',
  product_review: 'Review',
  football: 'Futebol',
  nasa_apod: 'APOD',
  quiz: 'Quiz',
  etymology: 'Etimologia',
  ranked: 'Ranked',
  code_levels: 'Code Levels',
  cortes: 'Cortes',
  youtube_upload: 'Upload',
  upload: 'Upload',
  studio_thumbnail: 'Capa',
  scheduled_upload: 'Publicação',
  studio_engagement: 'Interações',
  'channel_recovery.apply': 'Recuperar canal',
}

/**
 * O rótulo do tipo do job na lista de Jobs.
 *
 * A geração do Scheduler na fila (`scheduled_generation`, F3) é um tipo só
 * para todas as factories: o rótulo sai da factory que a rota ou o tick
 * semeou em `detail.factory`, mais a origem (`detail.triggered_by`). Sem a
 * factory, fica "Geração do Scheduler".
 */
export function jobKindLabel(job: Pick<Job, 'type' | 'detail'>): string {
  if (job.type === 'scheduled_generation') return scheduledGenerationLabel(job.detail)
  return FRIENDLY[job.type] ?? job.type
}

function scheduledGenerationLabel(detail: Job['detail']): string {
  const factory = typeof detail?.['factory'] === 'string' ? detail['factory'] : ''
  if (!factory) return 'Geração do Scheduler'
  const origin = detail?.['triggered_by'] === 'manual' ? 'Gerar agora' : 'Agendado'
  return `${FRIENDLY[factory] ?? factory} · ${origin}`
}

/**
 * Se o "Continuar" da tela de Jobs aparece: só nos jobs falhos dos tipos que
 * a retomada aceita ( e ). Os outros, como as capas
 * () e a publicação de um canal (),
 * dariam 422.
 */
export function canRetryJob(job: Pick<Job, 'status' | 'type'>): boolean {
  return job.status === 'failed' && (job.type === 'upload' || job.type === 'viral_shorts')
}
